import React, { useState, useCallback, ReactNode } from 'react';

// Defina o tipo para o estado inicial do toast
interface Toast {
  id: number;
  text: string;
  type: 'success' | 'info' | 'error';
  expireTime?: number;
}

const initialToastState: Toast[] = [];

// Defina o tipo para as props do ToastProvider

interface ToastProviderProps {
  children: ReactNode;
}

const ToastContext = React.createContext<{
  toasts: Toast[];
  showToast: (newToast: Omit<Toast, 'id'>) => void;
  hideToast: (id: number) => void;
  notifySuccess: (text: string) => void;
  notifyInfo: (text: string) => void;
  notifyError: (text: string) => void;
} | undefined>(undefined);

const ToastProvider: React.FC<ToastProviderProps> = ({ children }) => {
  const [toasts, setToasts] = useState<Toast[]>(initialToastState); 
  const showToast = useCallback((newToast: Omit<Toast, 'id'>) => {
    const id = Date.now();
    setToasts(prevToasts => [...prevToasts, { ...newToast, id }]);
    if (newToast.expireTime) {
      setTimeout(() => {
        setToasts(prevToasts => prevToasts.filter(toast => toast.id !== id));
      }, newToast.expireTime);
    }
}, []);


  const hideToast = useCallback((id: number) => {
    setToasts(prevToasts => prevToasts.filter(toast => toast.id !== id)); // Remove o toast com o ID específico
  }, []);

  const notifySuccess = (text: string) => showToast({ text, type: 'success', expireTime: 6000 });
  const notifyInfo = (text: string) => showToast({ text, type: 'info', expireTime: 6000 });
  const notifyError = (text: string) => showToast({ text, type: 'error', expireTime: 6000 });

  return (
    <ToastContext.Provider value={{ toasts, showToast, hideToast, notifySuccess, notifyError, notifyInfo }}>
      {children}
    </ToastContext.Provider>
  );
};

export { ToastProvider, ToastContext };